import React, { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { LuArrowUpDown } from "react-icons/lu";
import "../assets/css/styles.css";
import Popover from "./popover";
import axiosInstance from "../services/axiosInstance";
import WorkflowSheet from "./workflowSheet";
import generatePDF, { Resolution, Margin } from "react-to-pdf";
import CheckinPopup from "../Popup/checkinPopup";
import ViewSheetPopup from "../Popup/viewSheetPopup";
import { useNavigate } from "react-router-dom";
import { encrypt } from "../utils/cryptoUtils";
import { PropagateLoader } from "react-spinners";
import UploadOrderImagePopup from "../Popup/UploadOrderImagePopup";
import ShippingLabel from "./ShippingLabel";
import JobSheetV2 from "./JobSheetV2";
import JobSheetInvoicePage from "./JobSheetInvoicePage";
import { OrderImageCategoryEnum } from "../enums/OrderEnum";

const SortIcon = ({ sortDirection }) => {
  if (sortDirection === "asc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  if (sortDirection === "desc") {
    return (
      <LuArrowUpDown className="ml-1 !w-4 !h-5" style={{ color: "#EFEFEF" }} />
    );
  }
  return (
    <LuArrowUpDown
      className="ml-1 !w-4 !h-5"
      style={{ color: "#EFEFEF", opacity: "1" }}
    />
  );
};

const customStyles = {
  headCells: {
    style: {
      backgroundColor: "#376EA4",
      color: "#FAFDFF",
      fontSize: "16px",
      fontFamily: "InterBold",
      textAlign: "left",
      padding: "15px",
      opacity: "1",
      position: "sticky",
      top: 0,
      zIndex: 10,
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
      },
    },
    hoverStyle: {
      color: "#FAFDFF",
      opacity: "1",
    },
  },
  rows: {
    style: {
      cursor: "pointer",
      fontSize: "16px",
      color: "#828282",
      padding: "6px",
      backgroundColor: "rgba(252, 252, 252, 0.5)",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      // overflow: "hidden",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px 8px",
      },
    },
    highlightOnHoverStyle: {
      fontSize: "16px",
      color: "#202020",
      padding: "6px",
      backgroundColor: "#F4F9FF",
      borderBottom: "1px solid rgba(239, 239, 239, 0.8)",
      borderTop: "1px solid rgba(239, 239, 239, 0.8)",
      "@media screen and (min-width: 1250px) and (max-width: 1600px)": {
        fontSize: "14px",
        padding: "4px",
      },
    },
  },
  table: {
    style: {
      display: "block",
      maxHeight: "calc(100vh - 330px)",
      height: "fit-content",
      overflowY: "auto",
      borderCollapse: "separate",
      borderSpacing: 0,
      "@media screen and (min-width: 1600px)": {
        maxHeight: "calc(100vh - 340px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 760px) and (max-width: 1250px)": {
        maxHeight: "calc(100vh - 330px)",
        overflowX: "hidden",
      },
      "@media screen and (min-width: 768px) and (max-width: 1024px)": {
        maxHeight: "calc(100vh - 360px)",
        overflowX: "hidden",
      },
    },
  },
};

const formatDueDeliveryDate = (dueDeliveryDate) => {
  if (!dueDeliveryDate) return "";

  const date = new Date(dueDeliveryDate);

  // Extract day, month, hours, and minutes
  const day = date.getDate().toString().padStart(2, "0");
  const month = (date.getMonth() + 1).toString().padStart(2, "0"); // Months are 0-indexed
  const hours = date.getHours().toString().padStart(2, "0");
  const minutes = date.getMinutes().toString().padStart(2, "0");

  // Format as dd.MM | HH:mm
  return `${day}.${month} | ${hours}:${minutes}`;
};

const ProductionOrdersTable = ({ searchTerm }) => {
  const [loading, setLoading] = useState(false);
  const [isGeneratingPdf, setIsGeneratingPdf] = useState(false);
  const [orders, setOrders] = useState([]);
  const [selectedOrderId, setSelectedOrderId] = useState();
  const [selectedRows, setSelectedRows] = useState([]);
  const [orderImageCategory, setOrderImageCategory] = useState("");
  const [isVisible, setIsVisible] = useState(false);
  const [openPopup, setOpenPopup] = useState(false);
  const [openCheckinPopup, setOpenCheckinPopup] = useState(false);
  const [openUploadImagePopup, setOpenUploadImagePopup] = useState(false);
  const [
    activeCameraOptionsTooltipOrderId,
    setActiveCameraOptionsTooltipOrderId,
  ] = useState(null);
  const [wfSheetData, setWfSheetData] = useState({
    patientName: "",
    dentistName: "",
    geoCode: "",
    workTypeDescription: "",
    workTypeName: "",
    departments: [],
  });
    const [shippingLabelWFData, setShippingLabelWFData] = useState({
      patientName: "",
      dentistName: "",
      geoCode: "",
      workTypeDescription: "",
      workTypeName: "",
      departments: [],
      deliveryDate: "",
    });
  const [jobSheetData, setJobSheetData] = useState({
    patientName: "",
    dentistName: "",
    standard_Notes: "",
    individual_Notes: "",
    workTypeDescription: "",
    workTypeName: "",
  });
  const [teethPositions, setTeethPositions] = useState([]);
  const navigate = useNavigate();

  const handleCreateButtonClick = (row) => {
    const encryptedId = encrypt(row.id.toString());
    navigate(`/order-creation?orderId=${encryptedId}`);
  };

  const UploadOrderImage = (orderId, file) => {
    alert(
      `Image upload initiated for order ID: ${orderId}. Check console for file details.`
    );
    setOpenUploadImagePopup(false);
  };

  const toggleCameraOptionsTooltip = (orderId) => {
    setActiveCameraOptionsTooltipOrderId((prevId) =>
      prevId === orderId ? null : orderId
    );
  };

  const handleOpenUploadPopupFromTooltip = (row, orderImageCategory) => {
    setOpenUploadImagePopup(true);
    setOrderImageCategory(orderImageCategory);
    setSelectedOrderId(row.id);
    setActiveCameraOptionsTooltipOrderId(null); // Close tooltip after action
  };

  const handleRowClick = (row) => {
    setSelectedRows((prevSelectedRows) => {
      const isSelected = prevSelectedRows.some((r) => r.id === row.id);
      if (isSelected) {
        // Remove row from selected rows
        return prevSelectedRows.filter((r) => r.id !== row.id);
      } else {
        // Add row to selected rows
        return [...prevSelectedRows, row];
      }
    });
  };

  const isRowSelected = (row) => {
    return selectedRows.some((r) => r.id === row.id);
  };

  const handleSendSelectedIds = async () => {
    const selectedIds = selectedRows.map((row) => row.id);
    try {
      const response = await axiosInstance.post("/api/order/PostCheckedIn", {
        ids: selectedIds,
      });
      if (response.isSuccess) {
        setOpenCheckinPopup(true);
        await fetchOrders();

        // Generate shipping label PDFs for each selected row, one after another
        for (const row of selectedRows) {
          setTimeout(async () => {
            await handleShippingLabel(row);
          }, 100);
          
        }
      } else {
        alert(response.message);
      }
    } catch (error) {
      console.error("Error sending selected IDs:", error);
    }
  };

  const HandleRemovePopUp = () => setOpenPopup(false);
  const HandleCloseCheckinPopup = () => setOpenCheckinPopup(false);
  const HandleCloseUploadImagePopup = () => {
    setOpenUploadImagePopup(false);
  };

  const option_wf = {
    method: "open",
    resolution: Resolution.NORMAL,
    page: {
      margin: Margin.SMALL,
      format: "A6",
      orientation: "landscape",
    },
    canvas: { mimeType: "image/png", qualityRatio: 1 },
    overrides: { canvas: { useCORS: true } },
  };
   const option_js = {
     method: "open",
     resolution: Resolution.NORMAL,
     page: {
       margin: Margin.SMALL,
       format: "A4",
       orientation: "portrait",
     },
     canvas: { mimeType: "image/png", qualityRatio: 1 },
     overrides: { canvas: { useCORS: true } },
   };

  const getTargetElement1 = () => document.getElementById("work-flow-sheet");
  const getTargetElement2 = () => document.getElementById("job-sheet-pdf-wrapper");
  const getShippingLabel = () => document.getElementById("shipping-label");

  const workflowSheetHandleClick = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleGeneratePDF1();
  };

  const generateShippingLabel = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleShittingLabelGeneratePDF();
  };

  const jobSheetHandleClick = () => {
    setOpenPopup(true);
    setIsVisible(true);
    handleGeneratePDF2();
  };

  const handleGeneratePDF1 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement1, option_wf);
      setIsVisible(false);
    }, 10);
  };

  const handleGeneratePDF2 = () => {
    setTimeout(() => {
      generatePDF(getTargetElement2, option_js);
      setIsVisible(false);
    }, 10);
  };

  const handleShittingLabelGeneratePDF = () => {
    setTimeout(() => {
      generatePDF(getShippingLabel, option_wf);
      setIsVisible(false);
    }, 10);
  };

  const handlePreviewWorkflowSheet = async (row) => {
    try {
      const rowId = row.id;
      const response = await axiosInstance.post(
        "/api/order/previewWorkflowSheet",
        {
          OrderId: parseInt(rowId, 10),
        }
      );
      //console.log("work flow pdf data", response);
      if (response) {
        setWfSheetData({
          patientName: response.patientName,
          dentistName: response.dentistName,
          geoCode: response.geoCode,
          workTypeDescription: response.workTypeDescription,
          workTypeName: response.workTypeName,
          departments: response.departments,
        });
        workflowSheetHandleClick();
      } else {
        alert("Failed to open pdf. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
  };

  const handleShippingLabel = async (row) => {
    try {
      const rowId = row.id;
      const response = await axiosInstance.post(
        "/api/order/previewWorkflowSheet",
        {
          OrderId: parseInt(rowId, 10),
        }
      );
      if (response) {
        setShippingLabelWFData({
          patientName: response.patientName,
          dentistName: response.dentistName,
          geoCode: response.geoCode,
          workTypeDescription: response.workTypeDescription,
          workTypeName: response.workTypeName,
          departments: response.departments,
          deliveryDate: row.finalDeliveryRaw,
        });
        generateShippingLabel();
      } else {
        alert("Failed to open pdf. Please try again.");
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
  };

  const handlePreviewJobSheet = async (row) => {
    try {
      const rowId = row.id;
      const response = await axiosInstance.post(
        "/api/order/previewJobflowSheet",
        {
          OrderId: parseInt(rowId, 10),
        }
      );
      if (response) {
        setJobSheetData({
          patientName: response?.patientName,
          dentistName: response?.dentistName,
          standard_Notes: response?.standard_Notes || "",
          individual_Notes: response?.individual_Notes || "",
          workTypeDescription: response?.workTypeDescription || "",
          workTypeName: response?.workTypeName || "",
          invoiceInformationDetails: response?.invoiceInformationDetails || [],
        });
        setTeethPositions(response?.teethPositions);
        jobSheetHandleClick();
      } else {
        alert();
      }
    } catch (error) {
      console.error("Error fetching workflow data:", error);
    }
  };

  const handleViewPhotoPdf = async (
    orderId,
    category,
    categoryFriendlyName
  ) => {
    setIsGeneratingPdf(true);
    setActiveCameraOptionsTooltipOrderId(null); // Close tooltip if needed

    try {
      const response = await axiosInstance.post(
        `/api/OrderAttachments/photosToToothColourPdf?orderId=${orderId}&orderImageCategory=${category}`,
        null,
        {
          responseType: "blob",
          headers: {
            Accept: "application/pdf",
          },
        }
      );

      // Create blob and trigger download
      const blob = new Blob([response], { type: "application/pdf" });
      const url = window.URL.createObjectURL(blob);

      const downloadLink = document.createElement("a");
      downloadLink.href = url;
      downloadLink.download = `Order_${orderId}_Images.pdf`;
      document.body.appendChild(downloadLink);
      downloadLink.click();

      // Cleanup
      document.body.removeChild(downloadLink);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error(`Error generating PDF for ${categoryFriendlyName}:`, error);

      let errorMessage = `Fehler beim Erstellen des PDFs für ${categoryFriendlyName}.`;

      if (error.response?.data instanceof Blob) {
        // Parse blob error response
        const errorText = await new Promise((resolve) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.readAsText(error.response.data);
        });

        try {
          const errorJson = JSON.parse(errorText);
          errorMessage += ` ${
            errorJson.message || errorJson.detail || errorText
          }`;
        } catch {
          errorMessage += ` ${errorText}`;
        }
      } else if (error.response?.data?.message) {
        errorMessage += ` ${error.response.data.message}`;
        if (error.response.data.detail) {
          errorMessage += ` (${error.response.data.detail})`;
        }
      } else {
        errorMessage += ` ${error.message}`;
      }

      alert(errorMessage);
    } finally {
      setIsGeneratingPdf(false);
    }
  };

  const columns = [
    {
      name: "Praxis",
      selector: (row) => row.dentistName,
      sortable: true,
      width: "16%",
      sortFunction: (a, b) => a.dentistName.localeCompare(b.dentistName),
    },
    {
      name: "Patient",
      selector: (row) => row.patientName,
      sortable: true,
      width: "12%",
      sortFunction: (a, b) => a.patientName.localeCompare(b.patientName),
    },
    {
      name: "Arbeitsart",
      selector: (row) => row.workTypeName,
      sortable: true,
      width: "15%",
      sortFunction: (a, b) => a.workTypeName.localeCompare(b.workTypeName),
    },
    {
      id: "dueDeliveryColumn", // Add this line
      name: "Eingang bis",
      selector: (row) => new Date(row.dueDeliveryRaw),
      sortable: true,
      width: "11%",
      format: (row) => row.dueDelivery,
      sortFunction: (a, b) =>
        new Date(a.dueDeliveryRaw) - new Date(b.dueDeliveryRaw),
    },
    {
      name: "Liefertermin",
      selector: (row) => new Date(row.finalDeliveryRaw),
      sortable: true,
      width: "11%",
      format: (row) => row.finalDelivery,
      sortFunction: (a, b) =>
        new Date(a.finalDeliveryRaw) - new Date(b.finalDeliveryRaw),
    },
    {
      id: "listStatus",
      name: "Vorschau",
      selector: (row) => row.create,
      sortable: false,
      width: "35%",
      cell: (row) => (
        <div className="gap-3 flex">
          {/* Camera Button */}
          <Popover>
            <div className="relative">
              <button
                onClick={() => toggleCameraOptionsTooltip(row.id)}
                className="rounded-lg p-1.5 my-1 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
                style={{
                  backgroundColor: "rgba(201, 226, 252, 0.3)",
                  borderRadius: "5px",
                  cursor: "pointer",
                }}
              >
                <img
                  src="./icons/camera.svg"
                  className="mx-auto"
                  alt="Camera"
                />
              </button>
              {activeCameraOptionsTooltipOrderId === row.id && (
                <div className="absolute bottom-full gap-3 z-20 left-1/2 -translate-x-1/2 mb-2 w-max bg-stone-100 p-2 rounded-md shadow-lg border border-gray-200 flex items-center space-x-1 z-20 after:content-[''] after:absolute after:left-1/2 after:-translate-x-1/2 after:top-full after:w-0 after:h-0 after:border-l-[8px] after:border-l-transparent after:border-r-[8px] after:border-r-transparent after:border-t-[8px] after:border-t-white">
                  <button
                    title="Photo of tooth colour"
                    onClick={() =>
                      handleOpenUploadPopupFromTooltip(
                        row,
                        OrderImageCategoryEnum.PhotoOfTooth
                      )
                    }
                    className="rounded-lg p-1.5 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
                    style={{
                      backgroundColor: "rgba(201, 226, 252, 0.3)",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="./icons/paint_icon.svg"
                      alt="Photo of tooth colour"
                      className="mx-auto"
                    />
                  </button>
                  <button
                    title="Photo of finished work"
                    onClick={() =>
                      handleOpenUploadPopupFromTooltip(
                        row,
                        OrderImageCategoryEnum.PhotoOfFinishedWork
                      )
                    }
                    className="rounded-lg p-1.5 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
                    style={{
                      backgroundColor: "rgba(201, 226, 252, 0.3)",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="./icons/picture_icon.svg"
                      alt="photo of finished work"
                      className="w-5 h-5"
                    />
                  </button>
                  <button
                    title="Original order"
                    onClick={() => {
                      handleOpenUploadPopupFromTooltip(
                        row,
                        OrderImageCategoryEnum.PhotoOfOriginalOrder
                      );
                    }}
                    className="rounded-lg p-1.5 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
                    style={{
                      backgroundColor: "rgba(201, 226, 252, 0.3)",
                      borderRadius: "5px",
                      cursor: "pointer",
                    }}
                  >
                    <img
                      src="./icons/scan_print.svg"
                      alt="original order"
                      className="w-5 h-5"
                    />
                  </button>
                </div>
              )}
            </div>
          </Popover>

          <popover
            trigger="hover"
            content={
              <p className="absolute right-0 text-blue-400 pt-2 px-2 py-1 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-3  after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit">
                Photo of tooth colour
              </p>
            }
          >
            <button
              disabled={row.photoOfToothCount === 0}
              title="photo of tooth colour"
              onClick={() => {
                if (!isGeneratingPdf) {
                  handleViewPhotoPdf(
                    row.id,
                    OrderImageCategoryEnum.PhotoOfTooth
                  );
                }
              }}
              className={`rounded-lg p-1.5 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] ${
                row.photoOfToothCount === 0
                  ? "opacity-50 hover:border-transparent cursor-not-allowed"
                  : ""
              }`}
              style={{
                backgroundColor:
                  row.photoOfToothCount === 0
                    ? "#E0E0E0"
                    : "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: row.photoOfToothCount === 0 ? "not-allowed" : "pointer",
              }}
            >
              <img
                src="./icons/paint_icon.svg"
                alt="photo of tooth colour"
                className="w-5 h-5"
              />
            </button>
          </popover>

          <popover
            trigger="hover"
            content={
              <p className="absolute right-0 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-3  after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit">
                Photo of finished work
              </p>
            }
          >
            <button
              disabled={row.photoOfFinishedWorkCount === 0 || isGeneratingPdf}
              title={
                row.photoOfFinishedWorkCount === 0
                  ? "Keine Bilder vorhanden"
                  : isGeneratingPdf
                  ? "PDF wird erstellt..."
                  : "PDF für fertige Arbeit anzeigen"
              }
              onClick={() => {
                if (!isGeneratingPdf) {
                  handleViewPhotoPdf(
                    row.id,
                    OrderImageCategoryEnum.PhotoOfFinishedWork
                  );
                }
              }}
              className={`rounded-lg p-1.5 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] ${
                row.photoOfFinishedWorkCount === 0
                  ? "opacity-50 hover:border-transparent cursor-not-allowed"
                  : isGeneratingPdf
                  ? "opacity-50 cursor-wait"
                  : ""
              }`}
              style={{
                backgroundColor:
                  row.photoOfFinishedWorkCount === 0
                    ? "#E0E0E0"
                    : "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor:
                  row.photoOfFinishedWorkCount === 0
                    ? isGeneratingPdf
                      ? "wait"
                      : "not-allowed"
                    : "pointer",
              }}
            >
              <img
                src="./icons/picture_icon.svg"
                alt="PDF für fertige Arbeit anzeigen"
                className={`w-5 h-5 ${
                  row.photoOfFinishedWorkCount === 0 ? "grayscale" : ""
                }`}
              />
            </button>
          </popover>

          <popover
            trigger="hover"
            content={
              <p className="absolute right-0 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-3  after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit">
                Photo of tooth colour
              </p>
            }
          >
            <button
              disabled={row.photoOfOriginalOrderCount === 0}
              title="Kamera wechseln (Platzhalter)"
              onClick={() => {
                if (!isGeneratingPdf) {
                  handleViewPhotoPdf(
                    row.id,
                    OrderImageCategoryEnum.PhotoOfOriginalOrder
                  );
                }
              }}
              className={`rounded-lg p-1.5 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)] ${
                row.photoOfOriginalOrderCount === 0
                  ? "opacity-50 hover:border-transparent cursor-not-allowed"
                  : ""
              }`}
              style={{
                backgroundColor:
                  row.photoOfOriginalOrderCount === 0
                    ? "#E0E0E0"
                    : "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor:
                  row.photoOfOriginalOrderCount === 0
                    ? "not-allowed"
                    : "pointer",
              }}
            >
              <img
                src="./icons/scan_print.svg"
                alt="Switch Camera"
                className="w-5 h-5"
              />
            </button>
          </popover>

          <Popover
            trigger="hover"
            content={
              <p className="absolute right-0 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-3  after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit">
                Bearbeiten
              </p>
            }
          >
            <button
              onClick={() => handleCreateButtonClick(row)}
              className="rounded-lg p-1.5 w-10 h-10 my-1 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/edit_square.svg" className="mx-auto" />
            </button>
          </Popover>

          {/* JobSheet */}
          <Popover
            trigger="hover"
            content={
              <p className="absolute -right-4 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-7  after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit">
                Auftragszettel
              </p>
            }
          >
            <button
              onClick={() => handlePreviewJobSheet(row)}
              className="rounded-lg p-1.5 my-1 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/Jobsheet.svg" className="mx-auto" />
            </button>
          </Popover>
          {/* workflow */}
          <Popover
            trigger="hover"
            content={
              <p className="absolute -right-1 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-5 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit">
                Auftragsablauf
              </p>
            }
          >
            <button
              onClick={() => handlePreviewWorkflowSheet(row)}
              className="rounded-lg p-1.5 my-1 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/flowchart.svg" className="mx-auto" />
            </button>
          </Popover>
          {/* Shipping Label */}
          <Popover
            trigger="hover"
            content={
              <p className="absolute -right-1 text-blue-400 px-2 py-0.5 3xl:py-1 leading-5 bg-blue rounded w-auto -top-7 text-lg xl:text-xs 3xl:text-lg whitespace-nowrap after:content-[' '] after:-bottom-2 after:right-5 after:absolute after:border after:border-l-8 after:border-r-8 after:border-transparent after:w-0 after:h-0 after:m-auto after:border-t-[10px] after:border-t-blue shadow-[2px_2px_4px_1px_rgba(0,0,0,0.2)] max-w-fit">
                Auftragsablauf
              </p>
            }
          >
            <button
              onClick={() => handleShippingLabel(row)}
              className="rounded-lg p-1.5 my-1 w-10 h-10 mx-auto border hover:border-blue-600 border-transparent shadow-[0_0_4px_rgba(55,110,164,0.2)]"
              style={{
                backgroundColor: "rgba(201, 226, 252, 0.3)",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              <img src="./icons/shipping_label.svg" className="mx-auto" />
            </button>
          </Popover>
        </div>
      ),
      allowoverflow: true,
      button: true,
    },
  ];

  useEffect(() => {
    fetchOrders();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        activeCameraOptionsTooltipOrderId &&
        !event.target.closest(".relative")
      ) {
        setActiveCameraOptionsTooltipOrderId(null);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [activeCameraOptionsTooltipOrderId]);

  const fetchOrders = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        "/api/order/getProductionOrders"
      );
      if (response) {
        if (Array.isArray(response)) {
          const mappedOrders = response.map((order) => {
            return {
              id: order.orderId,
              dentistName: order.dentistName || "",
              patientName: order.patientName,
              workTypeName: order.workTypeName,
              dueDelivery: formatDueDeliveryDate(order.dueDeliveryDate),
              dueDeliveryRaw: order.dueDeliveryDate, // Store raw date for sorting
              finalDelivery: formatDueDeliveryDate(order.deliveryDate),
              finalDeliveryRaw: order.deliveryDate, // Store raw date for sorting
              isDue:
                new Date(order.deliveryDate) < new Date(order.dueDeliveryDate),
              create: "",
              photoOfToothCount: order.photoOfToothCount || 0,
              photoOfFinishedWorkCount: order.photoOfFinishedWorkCount || 0,
              photoOfOriginalOrderCount: order.photoOfOriginalOrderCount || 0,
            };
          });

          setOrders(mappedOrders);
          setSelectedRows([]);
        } else {
          setOrders([]);
          setSelectedRows([]);
        }
      } else {
        setOrders([]);
        setSelectedRows([]);
      }
    } catch (error) {
      setOrders([]);
      setSelectedRows([]);
    } finally {
      setLoading(false);
    }
  };

  const filteredOrders = React.useMemo(() => {
    const clonedOrders = [...orders];
    return clonedOrders.filter(
      (order) =>
        order.dentistName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.patientName.toLowerCase().includes(searchTerm.toLowerCase()) ||
        order.workTypeName.toLowerCase().includes(searchTerm.toLowerCase())
    );
  }, [orders, searchTerm]);

  return (
    <div>
      <style>
        {`
          #work-flow-sheet.hidden {
            display: none;
          }        
        `}
      </style>
      <div>
        {loading ? (
          <div className="flex justify-center items-center min-h-60">
            <PropagateLoader color="rgb(55 110 164 / var(--tw-bg-opacity, 1))" />
          </div>
        ) : (
          <>
            <DataTable
              defaultSortFieldId="dueDeliveryColumn"
              defaultSortAsc={true}
              noDataComponent={
                <div className="py-4 text-gray-500">
                  Es sind keine Datensätze zum Anzeigen vorhanden
                </div>
              }
              className="production_order_tbl mt-7 !rounded-xl shadow-[0_0_8px_rgba(44,99,152,0.2)] font-interRegular custom-table-wrapper"
              scrollable
              scrollHeight="600px"
              columns={columns}
              data={filteredOrders}
              pagination={false}
              // selectableRows
              // onSelectedRowsChange={handleRowSelected}
              fixedHeader
              customStyles={customStyles}
              sortIcon={<SortIcon />}
              highlightOnHover={false}
              onRowClicked={handleRowClick}
              conditionalRowStyles={[
                {
                  when: (row) => row.isDue,
                  style: {
                    backgroundColor: "#FE725C33",
                    color: "#828282",
                  },
                },
                {
                  when: (row) => isRowSelected(row),
                  style: {
                    backgroundColor: "#cce5ff",
                    color: "#004085",
                  },
                },
              ]}
            />
            {!loading && (
              <div className="text-end mt-4">
                <button
                  className={`bg-blue text-2xl xl:!text-base 3xl:!text-2xl uppercase border ${
                    selectedRows.length > 0
                      ? "border-blue hover:bg-blue-800 hover:border-blue-800 text-white"
                      : "border-gray-300 bg-gray-300 text-gray-500 cursor-not-allowed"
                  } font-robotoBold py-2 px-5 rounded-lg focus:outline-none focus:shadow-outline transition-all ease-in`}
                  type="button"
                  onClick={handleSendSelectedIds}
                  disabled={selectedRows.length === 0}
                >
                  Freigeben
                </button>
              </div>
            )}
          </>
        )}
      </div>

      {/* modal popup */}
      <ViewSheetPopup openPopUp={openPopup} closePopUp={HandleRemovePopUp} />
      <CheckinPopup
        openPopUp={openCheckinPopup}
        closePopUp={HandleCloseCheckinPopup}
      />

      {/* Image Upload popup */}
      <UploadOrderImagePopup
        fetchOrders={fetchOrders}
        openPopUp={openUploadImagePopup}
        closePopUp={HandleCloseUploadImagePopup}
        orderId={selectedOrderId}
        orderImageCategory={orderImageCategory}
        onUpload={UploadOrderImage}
      />

      {/* job sheet */}
      <div
        id="job-sheet-pdf-wrapper"
        style={{
          width: "794px", // A4 width at 96 DPI
          minHeight: "1123px", // A4 height at 96 DPI
          backgroundColor: "white",
          ...(!isVisible && { display: "none" }),
        }}
      >
        {/* 1st Page */}
        <JobSheetV2
          jobSheetData={jobSheetData}
          isVisible={isVisible}
          toothGridData={teethPositions}
        />

        {/* 2nd Page */}
        {/* <JobSheetInvoicePage
          isVisible={isVisible}
          jobSheetData={jobSheetData}
        /> */}
      </div>

      {/* work flow sheet */}
      <WorkflowSheet
        wfSheetData={wfSheetData}
        formatDueDeliveryDate={formatDueDeliveryDate}
        isVisible={isVisible}
      />

      {/* shipping label */}
      <ShippingLabel
        shippingLabelWFData={shippingLabelWFData}
        formatDueDeliveryDate={formatDueDeliveryDate}
        isVisible={isVisible}
      />
    </div>
  );
};

export default ProductionOrdersTable;
